<template>
  <div id="app">
    <b-loading
      class="app-loading"
      :is-full-page="true"
      :active.sync="$store.state.loading"
    >
      <div class="loading-icon" />
      <span class="text">{{ $store.state.loadingText }}</span>
    </b-loading>

    <nav class="navbar is-fixed-top">
      <div class="container">
        <div class="navbar-brand">
          <router-link
            class="navbar-item"
            to="/"
          >
            <img
              src="./assets/logo.png"
              width="38"
              height="38"
              style="margin-right: 20px"
            >
            <img
              src="./assets/img/poly.png"
              width="68"
              height="28"
            >
          </router-link>

          <a
            role="button"
            class="navbar-burger"
            :class="{'is-active': active}"
            aria-label="menu"
            aria-expanded="false"
            @click="active = !active"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>

        <div
          class="navbar-menu"
          :class="{'is-active': active}"
        >
          <div class="navbar-start">
            <router-link
              class="navbar-item"
              to="/explorer"
            >
              Explorer
            </router-link>
            <router-link
              class="navbar-item"
              to="/a-propos"
            >
              À propos
            </router-link>
            <router-link
              class="navbar-item"
              to="/jeu-de-donnees"
            >
              Jeu de données
            </router-link>
            <router-link
              class="navbar-item"
              to="/presentations"
            >
              Présentations
            </router-link>
            <router-link
              class="navbar-item"
              to="/nous-joindre"
            >
              Nous joindre
            </router-link>
          </div>

          <div class="navbar-end">
            <div class="navbar-item">
              <v-search />
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div id="wrapper">
      <div class="wrapper">
        <div
          v-if="$route.name != 'home'"
          class="section pt-20 pb-30"
        >
          <v-breadcrumbs />
        </div>

        <router-view v-if="$store.state.ready" />

        <portal-target name="tooltip" />
      </div>
    </div>

    <div class="footer">
      <div class="container">
        <div class="level">
          <div>
            <router-link
              to="/explore"
            >
              Explorer
            </router-link>
            <router-link
              to="/a-propos"
            >
              À propos
            </router-link>
            <router-link
              to="/jeu-de-donnees"
            >
              Jeu de données
            </router-link>
            <router-link
              to="/presentations"
            >
              Présentations
            </router-link>
            <router-link
              to="/nous-joindre"
            >
              Nous joindre
            </router-link>
          </div>
          <div>
            <img
              src="./assets/img/footer.gif"
              alt="Pied de page BanQ"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Search from "./components/Search.vue";
import Breadcrumbs from "./components/Breadcrumbs.vue";

export default {
	components: {
		"v-search": Search,
		"v-breadcrumbs": Breadcrumbs
	},
	data () {
		return {
			active: false
		};
	},
	watch: {
		"$route.name"() {
			this.active = false;
		}
	},
	created () {
		this.$store.dispatch("loadSongs");
	},
};
</script>

<style lang="scss">
@import '@/assets/scss/app.scss';
</style>
